import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useIntervalOption, useWidgets } from 'modules/Dashboard/Widgets/Hooks';
import { useEProctoringEventsAnalytics } from 'modules/Dashboard/Widgets/EProctoring/Hooks';

import { EProctoringEventsAnalytics } from './EProctoringEventsAnalytics.component';
import { UsersWidgetPlaceholder } from 'modules/Dashboard/Widgets/Users/Common';
import { WidgetSettings } from 'modules/Dashboard/Widgets/Common';
import { MOCKED_DATA } from 'modules/Dashboard/Widgets/EProctoring/EProctoringWidgets.utils';

export const EProctoringEventsAnalyticsContainer = ({ widget, isMock }) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const { intervalOption, setIntervalOption } = useIntervalOption({
    defaultOption: widget?.settings?.default_option || '7',
  });

  const { fetchEProctoringEventsAnalytics, eproctoringEventsAnalytics } =
    useEProctoringEventsAnalytics({ widgetType: widget?.type });
  const { saveWidgetSettings, removeActiveWidget } = useWidgets();

  useEffect(() => {
    if (isMock) return;

    fetchEProctoringEventsAnalytics(intervalOption);
  }, []);

  const handleChangeIntervalOption = (option) => {
    if (isMock) return;

    setIntervalOption(option);
    fetchEProctoringEventsAnalytics(option);
  };

  if (eproctoringEventsAnalytics?.loading) {
    return <UsersWidgetPlaceholder widget={widget} />;
  }

  if (isSettingsOpen) {
    return (
      <WidgetSettings
        widget={widget}
        onSave={saveWidgetSettings}
        onClose={() => setIsSettingsOpen(false)}
        onRemoveWidget={removeActiveWidget}
      />
    );
  }

  return (
    <EProctoringEventsAnalytics
      widget={widget}
      data={isMock ? MOCKED_DATA : eproctoringEventsAnalytics?.data}
      intervalOption={intervalOption}
      onChangeIntervalOption={handleChangeIntervalOption}
      onOpenSettings={() => setIsSettingsOpen(true)}
      isMock={isMock}
    />
  );
};

EProctoringEventsAnalyticsContainer.propTypes = {
  widget: PropTypes.object,
  isMock: PropTypes.bool,
};
